import React from "react";
import { FaTrash } from "react-icons/fa";

import AdminLineChartCard from "./AdminLineChartCard";

function VisitsChartCard({
  data,
  form,
  deleting,
  onChange,
  onDelete,
}) {
  return (
    <section className="space-y-4">
      <AdminLineChartCard
        title="Évolution des visites"
        subtitle="Nombre de visites enregistrées par date."
        data={data}
        dataKey="compteur"
        valueLabel="Visites"
        gradientId="visitsGradient"
        emptyText="Aucune visite enregistrée."
      />

      <article className="rounded-[2rem] border border-red-200 bg-red-50 p-5 dark:border-red-500/20 dark:bg-red-500/10">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-red-700 dark:text-red-200">
              Maintenance base
            </p>

            <h3 className="mt-2 font-titre text-xl font-bold text-slate-950 dark:text-white">
              Supprimer des visites obsolètes
            </h3>

            <p className="mt-2 text-sm font-medium leading-6 text-slate-600 dark:text-white/60">
              Utilise cette action avec prudence pour nettoyer une période de
              visites.
            </p>
          </div>

          <div className="grid w-full gap-2 sm:grid-cols-3 xl:max-w-2xl">
            <input
              type="date"
              name="dateDebut"
              value={form.dateDebut}
              onChange={onChange}
              className="h-12 rounded-2xl border border-red-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-red-300 focus:ring-4 focus:ring-red-100 dark:border-red-500/20 dark:bg-slate-950 dark:text-white dark:focus:ring-red-500/10"
            />

            <input
              type="date"
              name="dateFin"
              value={form.dateFin}
              onChange={onChange}
              className="h-12 rounded-2xl border border-red-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-red-300 focus:ring-4 focus:ring-red-100 dark:border-red-500/20 dark:bg-slate-950 dark:text-white dark:focus:ring-red-500/10"
            />

            <button
              type="button"
              onClick={onDelete}
              disabled={deleting}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-red-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
            >
              <FaTrash />
              {deleting ? "Suppression..." : "Supprimer"}
            </button>
          </div>
        </div>
      </article>
    </section>
  );
}

export default VisitsChartCard;